import { createSlice } from "@reduxjs/toolkit";


const DetailsSlice = createSlice({
    name: "details",
    initialState:{
        MovieDetails: null,
        CardId:" ",
        showDetails : false,
        CastDetails : null,
        PopUp : false,
        ClipDetails : null,
    },
    
    reducers:{
        addMovieDetails: (state, action)=>{
            state.MovieDetails = action.payload;
        },
        addCardId:(state,action) => {
            state.CardId = action.payload;
        },
        toggleshowDetails: (state)=>{
            state.showDetails = !state.showDetails;   
        },
        togglePopUp: (state)=>{
            state.PopUp = !state.PopUp;   
        },
        addCastDetails:(state, action)=>{
            state.CastDetails = action.payload;
        },
        addClipDetails:(state, action)=>{
            state.ClipDetails = action.payload;
        }
    }
 });

 export const { addMovieDetails, addCardId , toggleshowDetails, addCastDetails, togglePopUp, addClipDetails} = DetailsSlice.actions;

 export default DetailsSlice.reducer;